<template>
    <div class="pd20x flex1">
      <Deliver :visible="deliverOpen" @close="deliverOpen = false"></Deliver>
      <div class="contentBox h100pct ofA">
        <div class="filter" style="padding:10px 20px">
          <!-- <div>
            <a-button type="primary" @click="openClasses">开课</a-button>
          </div> -->
          <div>
            <label>搜索：</label>
            <a-select v-model="selectVal" style="width: 120px" >
              <a-select-option :value="item.val" v-for="(item,index) in option" :key="index">
                {{item.name}}
              </a-select-option>
            </a-select>
            <a-input-search placeholder="请输入搜索内容" v-model="searchInput" style="width: 300px" @search="onSearch" class="mr10px"/>
          </div>
        </div>
        <a-table
          :columns="columns"
          :data-source="data"
          :rowKey="'uid'"
          :pagination="{pageSize: page.pageSize, total}"
          @change="changePage"
        >
          <template slot="headimgurl" slot-scope="text">
            <a-avatar icon="user" :src="text"/>
          </template>
          <template slot="nickname" slot-scope="text,record">
            <div>{{ record.nickname }}</div>
            <div>{{ record.mobile }}</div>
          </template>
            <!-- <template slot="status" slot-scope="text">
                <a-date-picker :defaultValue="momentDay(text)" @change="onChange" style="width:130px" />
            </template>
            <template slot="content2" slot-scope="text,record">
                <a-input :defaultValue="text" style="width: 130px" @blur="changeNum(e,record)"></a-input>
            </template> -->
          <template slot="isAgent" slot-scope="text,record">
            <a-switch :default-checked="record.isAgent == 1? true :false" @change="(e) => {changeAdmin(e, record.id)}"/>
          </template>
          <template slot="regTime" slot-scope="text">
            {{ text ? formatDate(text * 1000) : '--' }}
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-space>
              <span class="csP" style="color:#7ebae5" @click="openClasses(record)">试卷</span>
              <a-divider type="vertical" />
              <span v-if="record.tenant_id > 0" class="csP" style="color:#52c41a; font-weight: bold;" @click="goToTenant(record)">
                <a-icon type="bank" /> 已是机构
              </span>
              <span v-else class="csP" style="color:#1890ff; font-weight: 500;" @click="showQuickOpenTenant(record)">
                开通机构
              </span>
            </a-space>
          </template>
        </a-table>

        <!-- 一键开通机构弹窗 -->
        <a-modal
          title="一键为该用户开通合作机构"
          :visible="openTenantVisible"
          :confirm-loading="openTenantLoading"
          @ok="handleQuickOpenSubmit"
          @cancel="openTenantVisible = false"
          okText="立即开通"
          cancelText="取消"
          width="520px"
        >
          <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-form-item label="开通用户">
              <span style="font-weight: bold; color: #1890ff;">{{ currentStudent ? (currentStudent.nickname || currentStudent.mobile) : '' }}</span>
              <span style="color: #999; margin-left: 8px;">(UID: {{ currentStudent ? currentStudent.id : '' }})</span>
            </a-form-item>
            <a-form-item label="机构名称" required>
              <a-input v-model="tenantForm.tenant_name" placeholder="请输入机构/琴行名称" />
            </a-form-item>
            <a-form-item label="联系电话" required>
              <a-input v-model="tenantForm.contact_phone" placeholder="请输入机构绑定联系手机" />
            </a-form-item>
            <div style="background: #e6f7ff; border: 1px solid #91d5ff; border-radius: 6px; padding: 10px 14px; font-size: 12px; color: #0050b3; line-height: 1.6; margin-top: 10px;">
              <a-icon type="info-circle" /> <strong>开通后系统将自动：</strong>
              <br/>1. 为该用户生成独立机构档案与记账钱包；
              <br/>2. 自动赋予该账号机构管理员权限，前台可直接进入【机构管理后台】；
              <br/>3. 自动同步代理官方全部基础试卷包。
            </div>
          </a-form>
        </a-modal>
      </div>
    </div>
</template>
<script>
const columns = [
  { title: 'ID', dataIndex: 'id', align: 'center' },
  { title: '头像', dataIndex: 'headImg', align: 'center', scopedSlots: { customRender: 'headimgurl' } },
  { title: '学号', dataIndex: 'num', align: 'center' },
  { title: '信息', dataIndex: 'nickname', scopedSlots: { customRender: 'nickname' }, align: 'center' },
  // { title: '地址', dataIndex: 'content4', align: 'center' },
  // { title: '课程包信息', dataIndex: 'content5', align: 'center' },
  { title: '消费金额', dataIndex: 'consme', align: 'center' },
  { title: '老师', dataIndex: 'isAgent', scopedSlots: { customRender: 'isAgent' }, align: 'center' },
  { title: '注册时间', dataIndex: 'regTime', scopedSlots: { customRender: 'regTime' }, align: 'center' },
  // { title: '最近登录时间', dataIndex: 'content2', scopedSlots: { customRender: 'content2' }, align: 'center' },
  { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center' }
];
import Deliver from './student/deliver'
import { formatDate } from '@/libs/moment'
import * as http from '@/libs/examapi'
export default {
    name: 'students',
    components: { Deliver },
    data(){
        this.option = [
          { name: '昵称', val: 'nickname'},
          { name: '学号', val: 'num'},
          { name: '电话', val: 'mobile'}
        ]
        return{
          data:[],
          columns,
          searchInput: '',
          selectVal: 'nickname',
          deliverOpen: false,
          currentItem: null,
          filter:{},
          page:{
            pageSize: 15,
            page: 1
          },
          total: 0,
          openTenantVisible: false,
          openTenantLoading: false,
          currentStudent: null,
          tenantForm: {
            tenant_name: '',
            contact_phone: ''
          }
        }
    },
    mounted(){
      this.getData()
    },
    methods:{
      formatDate,
      changeAdmin(checked, id) {
        http.setUserAgent({uid: id, isadmin: checked?1:0}).then(res => {
          this.getData()
        })
      },
      getData(){
        http.getUserList({...this.page, ...this.filter}).then(res => {
          let {total, data} = res
          this.data = data
          this.total = total
        })
      },
      showQuickOpenTenant(record) {
        this.currentStudent = record
        const defaultName = (record.nickname || record.mobile) + '的乐理机构'
        this.tenantForm = {
          tenant_name: defaultName,
          contact_phone: record.mobile || ''
        }
        this.openTenantVisible = true
      },
      handleQuickOpenSubmit() {
        if (!this.tenantForm.tenant_name) {
          this.$message.warning('请输入机构名称')
          return
        }
        if (!this.tenantForm.contact_phone) {
          this.$message.warning('请输入绑定手机号')
          return
        }
        this.openTenantLoading = true
        http.quickOpenTenantForUser({
          user_id: this.currentStudent.id,
          tenant_name: this.tenantForm.tenant_name,
          contact_phone: this.tenantForm.contact_phone,
          contact_name: this.currentStudent.nickname || '负责人'
        }).then(res => {
          this.openTenantLoading = false
          if (res !== undefined) {
            this.$message.success('恭喜！该用户已成功开通为合作机构！')
            this.openTenantVisible = false
            this.getData()
          }
        }).catch(err => {
          this.openTenantLoading = false
          console.error(err)
          this.$message.error('开通失败，请检查网络或参数')
        })
      },
      goToTenant(record) {
        this.$router.push('/exam/tenantList')
      },
      openClasses({id}){
        console.log(id)
        this.$router.push({
          path: '/exam/courseLimit',
          query:{
            id
          }
        })
      },
      onSearch(){
        this.filter = {}
        this.filter[this.selectVal] = this.searchInput
        this.getData()
      },
      changePage(pagination){
        this.page.page = pagination.current
        this.getData()
      }
    }
}
</script>
